import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionsFailSection } from './components/SolutionsFailSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Divider } from './components/Divider';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-dark text-brand-light font-sans selection:bg-brand-accent/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <Divider data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <Divider data-id="element-4" />
      <SolutionsFailSection data-id="element-5" />
      <Divider data-id="element-6" />
      <MechanismSection data-id="element-7" />
      <Divider data-id="element-8" />
      <WhatYouGetSection data-id="element-9" />
      <Divider data-id="element-10" />
      <AudienceSection data-id="element-11" />
      <Divider data-id="element-12" />
      <HowItWorksSection data-id="element-13" />
      <Divider data-id="element-14" />
      <ProofSection data-id="element-15" />
      <Divider data-id="element-16" />
      <FAQSection data-id="element-17" />
      <Divider data-id="element-18" />
      <OfferSection data-id="element-19" />

      <Footer data-id="element-20" />
    </div>;
}